import _ from 'underscore';

let i18n = null;

export function initialize(options) {
  ({ i18n } = options);
}

/**
 * Update ads by bing to show the expected predicate and choices in the filter
 *
 * @param {Object} entitySchema - the option to update the filter
 * @returns {void}
*/
export function updateAdsByBingPropertyForFilter(entitySchema) {
  const hasAdsByBingOption = _.find(entitySchema.properties, prop => prop.name === 'AdsByBing');

  _.extend(hasAdsByBingOption, {
    operatorDisplayNameMap: { eq: i18n.getString('FilterLocalization_FilterOperator_Equal') },
    localized: {
      true: i18n.getString('Filter_BooleanFilter_Yes'),
      false: i18n.getString('Filter_BooleanFilter_No'),
    },
    chooseType: 'select',
  });
}

